import { render, staticRenderFns } from "./copyShop.vue?vue&type=template&id=1b13fa60&scoped=true"
import script from "./copyShop.vue?vue&type=script&lang=js"
export * from "./copyShop.vue?vue&type=script&lang=js"
import style0 from "./copyShop.vue?vue&type=style&index=0&id=1b13fa60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b13fa60",
  null
  
)

export default component.exports